import type { TechnologyCategoryDTO } from "app/pages/sales-intelligence/domain/technology/types/dto";

import type { CompanySearchTableFilters } from "../../company-search/types/common";
import type SignalsDTO from "../../signals/models/miscellaneous/SignalsDTO";

type FiltersDto = Partial<{
    [key: string]: unknown;
}>;

export type FiltersDescriptionResponseDto = {
    technologies: ReadonlyArray<TechnologyCategoryDTO>;
};

export type QueryFiltersDto = {
    contactsFilters: FiltersDto;
    leadsFilters: FiltersDto;
    appsFilters?: FiltersDto;
    signalsFilters?: Readonly<SignalsDTO>;
};

export type NewSearchDto = CompanySearchTableFilters & {
    name: string;
    device?: string;
    isNewOnly?: boolean;
    excludeUserLeads?: boolean;
    queryFilters: QueryFiltersDto;
    leadGenTrafficAggregationEnabled?: boolean;
};

export const SaveSearchAICreated = "Sales Assistant";

export type SavedSearchDto = NewSearchDto & {
    searchId: string;
    createdDate: string;
    numberOfNewWebsites: number;
    totalNumberOfWebsites: number;
    markedAsDeleted?: boolean;
    createdBy?: typeof SaveSearchAICreated;
};

export type SimplifiedSavedSearchDto = Pick<SavedSearchDto, "name" | "searchId" | "markedAsDeleted"> & {
    numberOfNewWebsites: number;
    totalNumberOfWebsites: number;
};
